import { createAction } from "@reduxjs/toolkit";
import type {
  RaiseComplaintRequest,
  ComplaintStatusRequest,
  ApiEnvelope,
  RaiseComplaintResponsePayload,
  ComplaintStatusResponsePayload,
  ApiErrorPayload,
  DispositionItem,
  ComplaintSearchRequest,
  ComplaintSearchResponsePayload,
} from "./bbpsComplaintTypes";

// raise complaint
export const raiseComplaintRequest = createAction<RaiseComplaintRequest>(
  "bbpsComplaint/raiseComplaintRequest",
);
export const raiseComplaintSuccess = createAction<
  ApiEnvelope<RaiseComplaintResponsePayload>
>("bbpsComplaint/raiseComplaintSuccess");
export const raiseComplaintFailure = createAction<ApiErrorPayload>(
  "bbpsComplaint/raiseComplaintFailure",
);
export const raiseComplaintReset = createAction(
  "bbpsComplaint/raiseComplaintReset",
);

// complaint status
export const complaintStatusRequest = createAction<ComplaintStatusRequest>(
  "bbpsComplaint/complaintStatusRequest",
);
export const complaintStatusSuccess = createAction<
  ApiEnvelope<ComplaintStatusResponsePayload>
>("bbpsComplaint/complaintStatusSuccess");
export const complaintStatusFailure = createAction<ApiErrorPayload>(
  "bbpsComplaint/complaintStatusFailure",
);
export const complaintStatusReset = createAction(
  "bbpsComplaint/complaintStatusReset",
);

// dispositions
export const fetchDispositionsRequest = createAction(
  "bbpsComplaint/dispositions/request",
);
// export const fetchDispositionsRequest = createAction<{ force?: boolean }>(
//   "bbpsComplaint/dispositions/request"
// );

export const fetchDispositionsSuccess = createAction<{
  items: DispositionItem[];
  message?: string;
}>("bbpsComplaint/dispositions/success");

export const fetchDispositionsFailure = createAction<{
  message: string;
  statusCode?: number;
}>("bbpsComplaint/dispositions/failure");

export const fetchDispositionsReset = createAction(
  "bbpsComplaint/dispositions/reset",
);

// search raise
export const searchRaiseRequest = createAction<ComplaintSearchRequest>(
  "bbpsComplaint/searchRaiseRequest",
);
export const searchRaiseSuccess = createAction<
  ApiEnvelope<ComplaintSearchResponsePayload>
>("bbpsComplaint/searchRaiseSuccess");
export const searchRaiseFailure = createAction<ApiErrorPayload>(
  "bbpsComplaint/searchRaiseFailure",
);
export const searchRaiseReset = createAction("bbpsComplaint/searchRaiseReset");

// search status
export const searchStatusRequest = createAction<ComplaintSearchRequest>(
  "bbpsComplaint/searchStatusRequest",
);
export const searchStatusSuccess = createAction<
  ApiEnvelope<ComplaintSearchResponsePayload>
>("bbpsComplaint/searchStatusSuccess");
export const searchStatusFailure = createAction<ApiErrorPayload>(
  "bbpsComplaint/searchStatusFailure",
);
export const searchStatusReset = createAction("bbpsComplaint/searchStatusReset");
